import React, { Component } from 'react';
import {
  Jumbotron,
  Button,
  Form,
  Input,
  FormGroup,
} from 'reactstrap';
import requests from '../RequestsJumbotron/requests.json';
import RequestsList from "../RequestsList";
import { getItemsById } from "../../actions/armWrestlersActions";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Axios from 'axios';

class RequestsJumbotron extends Component {
  state = {
    email: "",
    tableVisible: false,
    tableData: []
  }

  handleValidSubmit = (e) => {
    e.preventDefault();
    console.log("handleValidSubmit");
    this.props.getItemsById(this.state.email);
    Axios
      .get(`/api/userInformation/${this.state.email}`)
      .then(res => {
        console.log(res.data)
        this.setState({ tableData: res.data })
      })

  }

  hideComponent = (name) => {
    switch (name) {
      case "tableVisible":
        this.setState({ tableVisible: !this.state.tableVisible });
        break;
      default:
    }
  }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  renderRequests = (e) => {
    if (true) {
      let requestList = requests.map((element) => {
        return (<li key={element.id}>{element.sites}{element.examType}{element.startDate}{element.endDate}{element.expireDate}</li>)
      })
      return <ul>{requestList}</ul>
    }
  }

  render() {
    return (
      <Jumbotron>
        <h2>Find your Requests</h2>
        <p className="lead"> Enter your email here to populate your requests
        <div>
          </div>
          <div id="requestSection">

            {/* {tableVisible &&  <RequestTable data={requests}/>} */}
            {/* {tableVisible &&  <RequestsList/>} */}
            <RequestsList tableData={this.state.tableData} handleValidSubmit={this.handleValidSubmit} />
          </div>
        </p>

      </Jumbotron>

    );
  };
}

// export default RequestsJumbotron;

RequestsJumbotron.propTypes = {
  getItemsById: PropTypes.func.isRequired,
  email: PropTypes.object.isRequired
}

// const mapDispatchToProps = dispatch => {
//   return {
//     // dispatching plain actions
//     getItems: () => dispatch({ type: 'GET_ITEMS' })
//   }
// }

const mapStateToProps = (state) => ({
  email: state.email
})

export default connect(
  mapStateToProps,
  { getItemsById }
)(RequestsJumbotron);